import { AnimatedCircularProgressBar } from '@/components/ui/animated-circular-progress-bar';
import { cn } from '@/lib/utils';

type DownloadProgressRingProps = {
  progress: number;
  label: string;
  className?: string;
};

export function DownloadProgressRing({
  progress,
  label,
  className,
}: DownloadProgressRingProps) {
  const boundedProgress = Math.min(100, Math.max(0, Math.round(progress)));

  return (
    <AnimatedCircularProgressBar
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={boundedProgress}
      value={boundedProgress}
      gaugePrimaryColor="var(--color-emerald-500)"
      gaugeSecondaryColor="var(--muted)"
      className={cn(
        'size-10 shrink-0 text-[10px] font-medium tabular-nums',
        className
      )}
    />
  );
}
